import React, { useEffect, useState } from "react";
import {
    CHANGE_PASSWORD_HEADER,
    PASSWORDREGEX,
    PASSWORD_ERROR,
    PASSWORD_NOT_SAME_ERROR,
    EMAILREGEX
} from "../../App.config";
import * as utilities from "../../utilities/utils";
import validation from "../../utilities/validation";

const PasswordExpiryComponent = (props) => {
    const initialState = {
        // email: {
        //     value: "",
        //     error: "",
        //     validation: {
        //         required: true,
        //         matchPattern: EMAILREGEX
        //     },
        // },
        oldPassword: {
            value: "",
            error: "",
            validation: {
                required: true,
            },
        },
        newPassword: {
            value: "",
            error: "",
            validation: {
                required: true,
                customMatchPattern: PASSWORDREGEX,
                type: PASSWORD_ERROR,
            },
        },
        confirmNewPasssword: {
            value: "",
            error: "",
            validation: {
                required: true,
            },
        },
        isSubmitOnce: { value: false },
    };

    const [state, setState] = useState(initialState);

    // clean on unmount
    // useEffect(() => {
    //   return () => {
    //     props.resetProfilePhoto();
    //   };
    // }, []);

    // useEffect(()=>{
    //     if(!props.modalReducer.isOpen)
    //         props.resetIsPasswordExpired(false);
    // },[props.modalReducer.isOpen]);

    const handleChanges = (event) => {
        let { name, value, checked, type, files } = event.target;

        let updatedObj = state[name];
        updatedObj.value = type === "checkbox" ? checked : value;

        if (state.isSubmitOnce.value) {
            FormValidation();
        }

        setState((state) => {
            return {
                ...state,
                [name]: updatedObj,
            };
        });
    };

    const FormValidation = () => {
        for (const property in state) {
            if (
                state[property]?.validation &&
                Object.keys(state[property].validation).length
            ) {
                let validatedObj = validation(state[property]);

                setState((state) => {
                    return {
                        ...state,
                        [property]: validatedObj,
                    };
                });
            }
        }
    };

    const isFormValid = () => {
        let isValid = true;
        for (const property in state) {
            if (
                state[property]?.validation &&
                Object.keys(state[property].validation).length
            ) {
                if (state[property]?.error.length > 0) {
                    isValid = false;
                }
            }
        }
        return isValid;
    };

    const isPasswordSame = () => {
        let isPasswordSame = false;

        let updatedConfirmNewPassword = { ...state.confirmNewPasssword };

        if (state.newPassword.value === state.confirmNewPasssword.value) {
            isPasswordSame = true;
            updatedConfirmNewPassword.error = "";
            setState((state) => {
                return {
                    ...state,
                    confirmNewPasssword: updatedConfirmNewPassword,
                };
            });
        } else {
            updatedConfirmNewPassword.error = PASSWORD_NOT_SAME_ERROR;
            setState((state) => {
                return {
                    ...state,
                    confirmNewPasssword: updatedConfirmNewPassword,
                };
            });
        }
        return isPasswordSame;
    };

    const onSubmit = () => {
        setState((state) => {
            return {
                ...state,
                isSubmitOnce: utilities.convertIntoObject(true),
            };
        });

        FormValidation();

        if (isFormValid() && isPasswordSame()) {
            let changePassowordInfo = {
                "userEmail": props.email,
                "currentPassword": state.oldPassword.value,
                "newPassword": state.newPassword.value,
            };
            props.changeExpiryPassword(changePassowordInfo);
        }
    };

    return (
        <div className="modal-dialog modal-dialog-centered" role="document">
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title" id="exampleModalLabel">
                        {CHANGE_PASSWORD_HEADER}
                    </h5>
                    <button
                        type="button"
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                        onClick={() => props.closeRemoveModal()}
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div className="modal-body">
                    <div className="alert alert-danger-custome" role="alert">
                        Your password is expired please change password here!
                    </div>
                    <span>
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="form-group">
                                    <label htmlFor="">
                                        Old Password
                                        <span size="5" className="error-star">
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="password"
                                        name="oldPassword"
                                        value={state.oldPassword.value}
                                        onChange={handleChanges}
                                        className="form-control"
                                        placeholder={props.context.t("Setting.Type.Here.text")}
                                    />
                                    {state.oldPassword?.error && (
                                        <span className="error">{state.oldPassword.error}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="form-group">
                                    <label htmlFor="">
                                        New Password
                    <span size="5" className="error-star">
                                            *
                    </span>
                                    </label>
                                    <input
                                        type="password"
                                        name="newPassword"
                                        value={state.newPassword.value}
                                        onChange={handleChanges}
                                        className="form-control"
                                        placeholder={props.context.t("Setting.Type.Here.text")}
                                    />
                                    {state.newPassword?.error && (
                                        <span className="error">{state.newPassword.error}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                <div className="form-group">
                                    <label htmlFor="">
                                        Confirm New Password
                    <span size="5" className="error-star">
                                            *
                    </span>
                                    </label>
                                    <input
                                        type="password"
                                        name="confirmNewPasssword"
                                        value={state.confirmNewPasssword.value}
                                        onChange={handleChanges}
                                        className="form-control"
                                        placeholder={props.context.t("Setting.Type.Here.text")}
                                        onPaste={(e) => e.preventDefault()}
                                    />
                                    {state.confirmNewPasssword?.error && (
                                        <span className="error">
                                            {state.confirmNewPasssword.error}
                                        </span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </span>
                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-secondary"
                        data-dismiss="modal"
                        onClick={onSubmit}
                    >
                        Update
          </button>
                </div>
            </div>
        </div>
    );
};
export default PasswordExpiryComponent;
